import { render, staticRenderFns } from "./OrderStatusMessage.vue?vue&type=template&id=5b4a0d82&"
import script from "./OrderStatusMessage.vue?vue&type=script&lang=js&"
export * from "./OrderStatusMessage.vue?vue&type=script&lang=js&"


/* normalize component */
import normalizer from "!../../../../../node_modules/vue-loader/lib/runtime/componentNormalizer.js"
var component = normalizer(
  script,
  render,
  staticRenderFns,
  false,
  null,
  null,
  null
  
)

export default component.exports